/* ==========================================================================
   Peonia Boutique · Mejoras de tienda (DAR Media)
   - Barra de progreso de envío gratis (cart drawer)
   - Recálculo de mensualidades (MSI) al cambiar de variante
   - Botón de compra fijo en móvil (pixel-safe)
   Vanilla JS, sin dependencias. Defensivo: si algo no existe, no rompe nada.
   ========================================================================== */
(function () {
  'use strict';

  function formatMoney(cents) {
    try {
      if (window.theme && theme.Currency && theme.settings && theme.settings.moneyFormat) {
        return theme.Currency.formatMoney(cents, theme.settings.moneyFormat);
      }
    } catch (e) {}
    return '$' + (Math.round(cents) / 100).toFixed(2);
  }

  /* ---------- A-01 · Barra de envío gratis ------------------------------- */
  function updateShippingBars(totalPriceCents) {
    var bars = document.querySelectorAll('[data-free-shipping-bar]');
    if (!bars.length) return;

    bars.forEach(function (bar) {
      var threshold = parseInt(bar.dataset.threshold, 10);
      if (!threshold || threshold <= 0) return;

      var remaining = threshold - totalPriceCents;
      var pct = Math.min(100, Math.round((totalPriceCents / threshold) * 100));
      if (pct < 0) pct = 0;

      var fill = bar.querySelector('[data-fsb-fill]');
      var msg = bar.querySelector('[data-fsb-msg]');
      if (fill) fill.style.width = pct + '%';

      if (remaining <= 0) {
        bar.classList.add('is-reached');
        if (msg) msg.innerHTML = bar.dataset.msgSuccess || '';
      } else {
        bar.classList.remove('is-reached');
        if (msg) {
          var tpl = bar.dataset.msgRemaining || '[amount]';
          msg.innerHTML = tpl.replace('[amount]', formatMoney(remaining));
        }
      }
    });
  }

  function refreshShippingFromCart() {
    // El mini-cart CMX gestiona su propia barra; si no hay barra nativa, no hacemos nada.
    if (!document.querySelector('[data-free-shipping-bar]')) return;
    var route = (window.theme && theme.routes && theme.routes.cart) || '/cart.js';
    fetch(route, { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) { updateShippingBars(cart.total_price); })
      .catch(function () {});
  }

  // El drawer reconstruye su HTML al añadir/quitar; reinyectamos el estado.
  document.addEventListener('cart:updated', function (evt) {
    if (evt.detail && evt.detail.cart) {
      updateShippingBars(evt.detail.cart.total_price);
    } else {
      refreshShippingFromCart();
    }
  });
  document.addEventListener('ajaxProduct:added', refreshShippingFromCart);
  document.addEventListener('cart:open', refreshShippingFromCart);

  /* ---------- A-03 · Mensualidades (MSI) en vivo ------------------------- */
  function updateInstallments(variant) {
    if (!variant || typeof variant.price !== 'number') return;
    document.querySelectorAll('[data-installments]').forEach(function (el) {
      var months = parseInt(el.dataset.months, 10);
      if (!months || months < 2) return;
      var amountEl = el.querySelector('[data-installments-amount]');
      if (amountEl) amountEl.innerHTML = formatMoney(Math.round(variant.price / months));
    });
  }

  /* ---------- UX-03 · Botón de compra fijo (móvil) ----------------------- */
  function updateStickyPrice(variant) {
    if (!variant || typeof variant.price !== 'number') return;
    document.querySelectorAll('[data-sticky-price]').forEach(function (el) {
      el.innerHTML = formatMoney(variant.price);
    });
  }

  document.addEventListener('variant:change', function (evt) {
    var variant = evt.detail && evt.detail.variant;
    if (!variant) return;
    updateInstallments(variant);
    updateStickyPrice(variant);
  });

  function initStickyAtc() {
    var sticky = document.querySelector('[data-sticky-atc]');
    if (!sticky) return;

    var sectionId = sticky.dataset.sectionId;
    var section = document.querySelector('.product-section[data-section-id="' + sectionId + '"]')
      || document.querySelector('.product-section');
    if (!section) return;

    var nativeBtn = section.querySelector('[data-add-to-cart]');
    var anchor = section.querySelector('.product-single__meta') || nativeBtn;
    if (!nativeBtn || !anchor) return;

    // El botón fijo dispara el ATC nativo (mantiene pixel y tracking intactos)
    var stickyBtn = sticky.querySelector('[data-sticky-atc-btn]');
    if (stickyBtn) {
      stickyBtn.addEventListener('click', function () {
        nativeBtn.click();
      });
    }

    // Reflejar disponibilidad del botón nativo
    function syncDisabled() {
      var disabled = nativeBtn.hasAttribute('disabled');
      if (stickyBtn) stickyBtn.disabled = disabled;
    }
    syncDisabled();
    document.addEventListener('variant:change', syncDisabled);

    // Mostrar la barra solo cuando ya pasamos (hacia abajo) el ATC nativo
    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          var scrolledPast = !entry.isIntersecting && entry.boundingClientRect.top < 0;
          if (scrolledPast) {
            sticky.classList.add('is-visible');
            sticky.setAttribute('aria-hidden', 'false');
          } else {
            sticky.classList.remove('is-visible');
            sticky.setAttribute('aria-hidden', 'true');
          }
        });
      });
      observer.observe(nativeBtn);
    }
  }

  /* ---------- SP-01 · Prueba social (datos reales) ----------------------- */
  function buildSocialProofQueue(items, cfg) {
    var out = [];
    var now = Date.now() / 1000;

    items.forEach(function (it) {
      // Una sola señal por producto, de la más accionable a la más genérica,
      // para no repetir el mismo producto seguido en la rotación.
      if (cfg.signals.lowStock && it.tracked && it.totalQty > 0 && it.totalQty <= cfg.lowStockThreshold) {
        var plantilla = it.totalQty === 1 && cfg.text.lowStockOne
          ? cfg.text.lowStockOne
          : cfg.text.lowStock;
        out.push({
          item: it,
          tag: String(plantilla).replace('{count}', it.totalQty),
          meta: it.lowTitle && cfg.text.size ? String(cfg.text.size).replace('{size}', it.lowTitle) : ''
        });
        return;
      }
      if (cfg.signals.newIn && it.createdAt && (now - it.createdAt) <= cfg.newDays * 86400) {
        out.push({ item: it, tag: cfg.text.newIn, meta: '' });
        return;
      }
      if (cfg.signals.popular && it.rank <= cfg.popularTop) {
        out.push({ item: it, tag: cfg.text.popular, meta: '' });
      }
    });

    for (var i = out.length - 1; i > 0; i--) {
      var j = Math.floor(Math.random() * (i + 1));
      var tmp = out[i]; out[i] = out[j]; out[j] = tmp;
    }
    return out;
  }

  function initSocialProof() {
    var root = document.querySelector('[data-psp]');
    var dataEl = document.querySelector('[data-psp-data]');
    var cfg = window.PEONIA_SOCIAL_PROOF;
    if (!root || !dataEl || !cfg) return;

    // Fuera del carrito, checkout y cuenta: ahí estorba y no aporta.
    if (/\/(cart|checkout|account|challenge|tools)(\/|$)/.test(window.location.pathname)) return;
    if (cfg.hideMobile && window.matchMedia('(max-width: 768px)').matches) return;

    // Modo revision: ?psp=demo acelera la rotacion para poder validarla sin
    // esperar el ciclo real. No cambia la configuracion guardada.
    if (/[?&]psp=demo/.test(window.location.search)) {
      cfg = Object.assign({}, cfg, { firstDelay: 1500, interval: 7000, duration: 4500 });
      try { sessionStorage.removeItem('psp:dismissed'); } catch (e) {}
    }

    try { if (sessionStorage.getItem('psp:dismissed') === '1') return; } catch (e) {}

    var items;
    try { items = JSON.parse(dataEl.textContent); } catch (e) { return; }
    if (!items || !items.length) return;

    var queue = buildSocialProofQueue(items, cfg);
    if (!queue.length) return;

    // Precargamos las miniaturas: la notificación dura pocos segundos y una
    // imagen que llega tarde se ve como un hueco gris.
    queue.slice(0, 6).forEach(function (m) {
      if (m.item.image) { var pre = new Image(); pre.src = m.item.image; }
    });

    var elLink = root.querySelector('[data-psp-link]');
    var elImg = root.querySelector('[data-psp-img]');
    var elTag = root.querySelector('[data-psp-tag]');
    var elTitle = root.querySelector('[data-psp-title]');
    var elMeta = root.querySelector('[data-psp-meta]');
    var idx = 0;
    var timer = null;
    var watcher = null;

    // La esquina inferior ya esta ocupada por el FAB del quiz, el boton de
    // WhatsApp y la barra de compra movil. Algunos de esos widgets crean su
    // propio stacking context con z-index maximo, asi que subir el nuestro no
    // sirve: hay que medir y esquivar. Escaneamos los elementos fijos que se
    // cruzan con la franja del widget en vez de asumir alturas fijas.
    function computeOffset() {
      var isMobile = window.matchMedia('(max-width: 768px)').matches;
      var margin = isMobile ? 12 : 18;
      var vh = window.innerHeight;
      var vw = window.innerWidth;
      var width = root.offsetWidth || 300;
      var bandLeft = cfg.position === 'bottom-right' ? vw - margin - width : margin;
      var bandRight = bandLeft + width;
      var offset = margin;

      var nodes = document.querySelectorAll('body > *, body > * > *');
      for (var i = 0; i < nodes.length; i++) {
        var el = nodes[i];
        if (el === root || root.contains(el)) continue;

        var cs = window.getComputedStyle(el);
        if (cs.position !== 'fixed' || cs.visibility === 'hidden' || cs.display === 'none') continue;
        if (parseFloat(cs.opacity) === 0) continue;

        var r = el.getBoundingClientRect();
        if (!r.width || !r.height) continue;
        if (r.bottom < vh * 0.55 || r.top > vh) continue;         // no esta en la franja inferior
        if (r.right <= bandLeft || r.left >= bandRight) continue; // no se cruza horizontalmente

        offset = Math.max(offset, vh - r.top + 10);
      }

      root.style.setProperty('--psp-offset', Math.round(offset) + 'px');
      return offset;
    }

    function render(msg) {
      var it = msg.item;
      elLink.href = it.url;
      if (elImg) {
        if (it.image) {
          elImg.src = it.image;
          elImg.alt = it.title;
          elImg.parentNode.style.display = '';
        } else {
          elImg.parentNode.style.display = 'none';
        }
      }
      elTag.textContent = msg.tag || '';
      elTitle.textContent = it.title;

      var meta = [];
      if (msg.meta) meta.push(msg.meta);
      if (cfg.showPrice && typeof it.price === 'number') meta.push(formatMoney(it.price));
      elMeta.textContent = meta.join(' · ');
    }

    function hideCurrent() {
      clearInterval(watcher);
      watcher = null;
      root.classList.remove('is-visible');
      timer = setTimeout(showNext, Math.max(1200, cfg.interval - cfg.duration));
    }

    function showNext() {
      // Con la pestana en segundo plano no gastamos turnos de la rotacion.
      if (document.hidden) {
        timer = setTimeout(showNext, 5000);
        return;
      }
      render(queue[idx % queue.length]);
      root.hidden = false;

      // Si la esquina esta saturada (chat abierto, barra de compra visible)
      // preferimos saltarnos el turno antes que tapar media pantalla.
      if (computeOffset() > window.innerHeight * 0.45) {
        timer = setTimeout(showNext, Math.max(5000, cfg.interval));
        return;
      }

      idx++;
      void root.offsetWidth;
      root.classList.add('is-visible');

      // El saludo de WhatsApp y otros widgets entran unos segundos despues de
      // cargar la pagina: si solo midieramos una vez, nos taparian a medio
      // camino. Revisamos la esquina mientras la notificacion esta a la vista.
      watcher = setInterval(computeOffset, 700);
      timer = setTimeout(hideCurrent, cfg.duration);
    }

    var closeBtn = root.querySelector('[data-psp-close]');
    if (closeBtn) {
      closeBtn.addEventListener('click', function () {
        clearTimeout(timer);
        clearInterval(watcher);
        root.classList.remove('is-visible');
        try { sessionStorage.setItem('psp:dismissed', '1'); } catch (e) {}
      });
    }

    window.addEventListener('resize', computeOffset);
    timer = setTimeout(showNext, cfg.firstDelay);
  }

  /* ---------- Init ------------------------------------------------------- */
  function init() {
    refreshShippingFromCart();
    initStickyAtc();
    initSocialProof();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
